import React, { useEffect, useCallback, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';

//Dependencies
import superagent from 'superagent';
import Parser from 'html-react-parser';

//Components
import { CircularProgress } from '@material-ui/core';

//Images
import Back from '../../images/productos/backGray.svg';
import Down from '../../images/productos/arrow-down.svg';
import pdfIcon from '../../images/productos/pdfimagen.png';
import download from '../../images/productos/downloadVideo.svg';

// Styles
import styles from './index.module.sass';

const Product = (props) => {
  const { webservice, device, history } = props;
  const { screenSize } = device;
  let { id = '' } = useParams();

  const [loading, setLoading] = useState(false);
  const [productID, setProductID] = useState('');
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [ingredients, setIngredients] = useState('');
  const [application, setApplication] = useState('');
  const [departamento, setdepartamento] = useState('0');
  const [rutaImagen, setrutaImagen] = useState(
    'https://webimages.terramarbrands.com.mx/shopping-cart/cart-products',
  );

  const [isOpen, setisOpen] = useState(true);
  const [isOpenIngredientes, setisOpenIngredientes] = useState(true);
  const [isOpenAplicacion, setisOpenAplicacion] = useState(true);

  const [existeRuta, setexisteRuta] = useState(false);
  const [existeRutaVideo, setexisteRutaVideo] = useState(false);

  const descRef = useRef(null);
  const ingRef = useRef(null);
  const appRef = useRef(null);

  const getDescriptions = useCallback(() => {
    window.scrollTo(0, 0);
    setLoading(true);
    const url = `${webservice}/getDescripciones?depto=0&clave=${id}`;
    superagent
      .get(url)
      .set('Content-Type', 'application/json')
      .then((res) => {
        const { body = {} } = res;
        const tmpProduct = (body.length > 0 && body[0]) || {};

        const {
          aplicacion = '',
          descripcion = '',
          clave = '',
          producto = '',
          ingredientes = '',
          departamento = '',
        } = tmpProduct;
        setProductID(clave);
        setName(producto);
        setDescription(descripcion);
        setIngredients(ingredientes);
        setApplication(aplicacion);
        setdepartamento(departamento);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, [webservice, id]);

  useEffect(() => {
    if (departamento === '1') {
      setrutaImagen('https://webimages.terramarbrands.com.mx/shopping-cart/color');
    } else {
      setrutaImagen('https://webimages.terramarbrands.com.mx/shopping-cart/cart-products');
    }
  }, [departamento]);

  useEffect(() => {
    if (productID) {
      // Para verificar si existe el PDF de la ficha tecnica
      const url = `https://api.terramarbrandsmx.com/webapiAdmincarritomx/api/general/ExisteRuta?ruta=https://webimages.terramarbrands.com.mx/webpage/productos/fichasTecnicas/${productID}.pdf`;
      superagent
        .get(url)
        .set('Content-Type', 'application/json')
        .then((res) => {
          setLoading(true);
          setexisteRuta(res.body.data);
          setLoading(false);
        });
    }
  }, [webservice, productID]);

  useEffect(() => {
    if (productID) {
      // Para verificar si existe el video de la ficha tecnica
      const url = `https://api.terramarbrandsmx.com/webapiAdmincarritomx/api/general/ExisteRuta?ruta=https://webimages.terramarbrands.com.mx/webpage/productos/videos/${productID}.mp4`;
      superagent
        .get(url)
        .set('Content-Type', 'application/json')
        .then((res) => {
          setLoading(true);
          setexisteRutaVideo(res.body.data);
          setLoading(false);
        });
    }
  }, [webservice, productID]);

  useEffect(() => {
    getDescriptions();
  }, [getDescriptions]);

  return (
    <>
      <div className={styles.back} onClick={() => history.push('/products')}>
        <img src={Back} alt='Back' className={styles.iconBack} /> Regresar
      </div>
      <div id={styles.Product} className={styles[screenSize]}>
        {(loading && <CircularProgress />) || (
          <>
            <div className={`${styles.imageContainer} ${styles[screenSize]}`}>
              <img
                src={`${rutaImagen}/${productID}.jpg`}
                alt={name}
                className={styles.imageProduct}
              />
            </div>
            <div className={styles.dataContainer}>
              <div className={`${styles.encabezadoProducto} ${styles[screenSize]}`}>
                <div className={styles.productName}>{name}</div>

                {existeRuta && (
                  <div>
                    <a
                      href={`https://webimages.terramarbrands.com.mx/webpage/productos/fichasTecnicas/${productID}.pdf`}
                      target='_blank'
                      rel='noopener noreferrer'
                      aria-label='Abrir ficha técnica'
                      className={styles.pdf}>
                      <label className={styles.pdf}>
                        <div className={styles.linkDescarga}>
                          <div>
                            <img src={pdfIcon} alt='imagen pdf' width='28px' />
                          </div>
                          <div>Ver ficha técnica</div>
                        </div>
                      </label>
                    </a>
                  </div>
                )}
              </div>

              <div className={styles.dataContent}>
                <div className={styles.data}>
                  <div className={styles.textContainer}>
                    <div className={styles.titleDiv} onClick={() => setisOpen(!isOpen)}>
                      <div>Descripción</div>
                      <div>
                        <img
                          src={Down}
                          alt='Down'
                          className={`${styles.icon} ${isOpen ? styles.rotate : ''}`}
                        />
                      </div>
                    </div>
                    <div
                      ref={descRef}
                      className={`${styles.info} ${isOpen ? styles.open : ''}`}
                      style={{
                        maxHeight: isOpen ? `${descRef.current?.scrollHeight}px` : '0px',
                      }}>
                      {Parser(description)}
                    </div>
                  </div>
                </div>
                <div className={styles.data}>
                  <div className={styles.textContainer}>
                    <div
                      className={styles.titleDiv}
                      onClick={() => setisOpenIngredientes(!isOpenIngredientes)}>
                      <div>Ingredientes</div>
                      <div>
                        <img
                          src={Down}
                          alt='Down2'
                          className={`${styles.icon} ${isOpenIngredientes ? styles.rotate : ''}`}
                        />
                      </div>
                    </div>
                    <div
                      ref={ingRef}
                      className={`${styles.info} ${isOpenIngredientes ? styles.open : ''}`}
                      style={{
                        maxHeight: isOpenIngredientes ? `${ingRef.current?.scrollHeight}px` : '0px',
                      }}>
                      {Parser(ingredients)}
                    </div>
                  </div>
                </div>
                <div className={styles.data}>
                  <div className={styles.textContainer}>
                    <div
                      className={styles.titleDiv}
                      onClick={() => setisOpenAplicacion(!isOpenAplicacion)}>
                      <div>Aplicación</div>
                      <div>
                        <img
                          src={Down}
                          alt='Down1'
                          className={`${styles.icon} ${isOpenAplicacion ? styles.rotate : ''}`}
                        />
                      </div>
                    </div>
                    <div
                      ref={appRef}
                      className={`${styles.info} ${isOpenAplicacion ? styles.open : ''}`}
                      style={{
                        maxHeight: isOpenAplicacion ? `${appRef.current?.scrollHeight}px` : '0px',
                      }}>
                      {Parser(application)}
                    </div>
                  </div>
                  {existeRutaVideo && (
                    <div className={styles.videoContainer}>
                      <video
                        src={`https://webimages.terramarbrands.com.mx/webpage/productos/videos/${productID}.mp4`}
                        controls
                        autoPlay
                        muted
                        loop
                        playsInline
                        poster='preview.jpg'
                        width='100%'></video>
                      <a
                        href={`https://webimages.terramarbrands.com.mx/webpage/productos/videos/${productID}.mp4?response-content-disposition=attachment`}
                        target='_blank'
                        rel='noopener noreferrer'
                        className={styles.video}>
                        <div className={styles.linkDescarga}>
                          <div>
                            <img src={download} alt='imagen download' width='28px' />
                          </div>
                          <div>Descargar video</div>
                        </div>
                      </a>
                      {/* <a
                      href={`https://webimages.terramarbrands.com.mx/webpage/productos/videos/${productID}.mp4`}
                      download>
                      Descargar video
                    </a> */}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Product;
